
interface PropsSplitDates {dates: string[]}
export function FilterDatesByLength({ dates }: PropsSplitDates): string[] {

    const years = dates.map(date => date.split('-')[0]);

    if (years.length > 69) {
        return years.map((_, i) => i % 20 === 0 ? _ : '');
    } else if (years.length > 49) {
        return years.map((_, i) => i % 10 === 0 ? _ : '');
    } else if (years.length > 29) {
        return years.map((_, i) => i % 5 === 0 ? _ : '');
    } else if (years.length > 19) {
        return years.map((_, i) => i % 4 === 0 ? _ : '');
    } else if (years.length > 9) {
        return years.map((_, i) => i % 3 === 0 ? _ : '');
    } else {
        return years;
    }
}

export const GenerateStars = (filledCount: number, totalCount: number) =>
  Array.from({ length: totalCount }, (_, index) => ({
      color: index < filledCount ? 'warning' : 'gray-300',
  }));

export function SearchedData<T> (data: T[], searchQuery: string) {
    const lowerQuery = searchQuery.toLowerCase()
    return data.filter(item => {
          return Object.values(item)
            .join(' ')
            .toLowerCase()
            .includes(lowerQuery)
      },
    )
}

export const CreateDynamicClass = (primary: string, secondary: string) => {
    const style = document.createElement('style');
    style.innerHTML = `
    .fill-primary svg [fill]:not(.permanent):not(g) {
      fill: ${primary} !important;
      transition: fill 0.3s ease;
    }
    
    .fill-secondary svg [fill]:not(.permanent):not(g) {
      fill: ${secondary} !important;
      transition: fill 0.3s ease;
    }
  `;
    document.head.appendChild(style);
};